import React from 'react';
import useShippingState from './useShippingState';
import PropTypes from "prop-types";
import CheckoutForm from "./CheckoutForm";



const PaymentForm = ({
    clientSecret,
    showError,
    onSuccess,
    customerName,
    deliveryChosen,
    paymentSucceeded }) => {

    const shippingState = useShippingState(customerName);

    return (
        <CheckoutForm
                clientSecret={clientSecret}
                shippingState={shippingState}
                deliveryChosen={deliveryChosen}
                showError={showError}
                onSuccess={onSuccess}
                paymentSucceeded={paymentSucceeded}/>       
    );
};

PaymentForm.propTypes = {  
    clientSecret: PropTypes.string.isRequired,
    customerName: PropTypes.string.isRequired,
    deliveryChosen: PropTypes.bool.isRequired,
    paymentSucceeded: PropTypes.bool.isRequired,
    onSuccess: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired
}


export default PaymentForm;